<template>
    <b-modal
        id="m-konfirmasi-refund"
        title="Konfirmasi Refund"
        no-close-on-backdrop
        no-close-on-esc
        hide-footer
        size="md"
        @hidden="onHidden"
    >
        <div v-if="refund">
            <!-- Info Refund -->
            <table class="table table-borderless table-sm mb-3">
                <tr>
                    <td style="width: 40%"><strong>Customer</strong></td>
                    <td>: {{ refund.customer && refund.customer.name }}</td>
                </tr>
                <tr>
                    <td><strong>Konser</strong></td>
                    <td>: {{ refund.concert && refund.concert.name }}</td>
                </tr>
                <tr>
                    <td><strong>Jumlah Refund</strong></td>
                    <td>
                        : <span>
                            Rp. {{ $helper.formatThousand(Math.abs(refund.amount)) }}
                        </span>
                    </td>
                </tr>
            </table>

            <hr />

            <!-- Upload Bukti Transfer -->
            <b-form-group>
                <template #label>
                    Bukti Transfer <span class="text-danger">*</span>
                </template>
                <b-form-file
                    v-model="tempFile"
                    accept="image/jpeg,image/png,image/jpg"
                    placeholder="Pilih file bukti transfer..."
                    browse-text="Pilih File"
                    @change="onFileChange"
                />
                <small class="text-muted">Format: JPG, PNG. Maks. 5MB.</small>

                <!-- Preview -->
                <div v-if="previewUrl" class="mt-2">
                    <img
                        :src="previewUrl"
                        class="img-thumbnail"
                        style="max-height: 150px; object-fit: contain;"
                    />
                </div>

                <!-- Loading upload -->
                <div v-if="isUploading" class="mt-2 text-muted small">
                    <i class="fa fa-spinner fa-spin mr-1" />Mengupload bukti...
                </div>
            </b-form-group>

            <!-- Catatan -->
            <b-form-group label="Catatan (opsional)">
                <b-form-textarea
                    v-model="form.notes"
                    rows="2"
                    maxlength="1000"
                    placeholder="Misal: Transfer BCA ref. 123456..."
                />
            </b-form-group>

            <!-- Tombol Submit -->
            <div class="mt-4 text-right">
                <b-button
                    variant="primary"
                    :disabled="isSubmitting || isUploading"
                    @click="confirmSubmit"
                >
                    <i class="fa fa-check mr-1" />
                    {{ isSubmitting ? "Menyimpan..." : "Konfirmasi Refund" }}
                </b-button>
            </div>
            
            <loading-overlay
                :fotoStartTime="uploadTimeStamp.startPresignedUrl"
                :fotoEndTime="uploadTimeStamp.endPresignedUrl"
                :uploadStartTime="uploadTimeStamp.startUploadToS3"
                :uploadEndTime="uploadTimeStamp.endUploadToS3"
                :penyimpananStartTime="uploadTimeStamp.startSaveFile"
                :penyimpananEndTime="uploadTimeStamp.endSaveFile"
                :show="isShowLoadingOverlay"
            />
        </div>
    </b-modal>
</template>

<script>
import LoadingOverlay from "../../barang-masuk/LoadingOverlay.vue";

export default {
    name: "ModalKonfirmasiRefund",

    components: {
        LoadingOverlay
    },

    data() {
        return {
            refund: null,
            isSubmitting: false,
            isUploading: false,
            isShowLoadingOverlay: false,

            tempFile: null,
            previewUrl: null,
            uploadedPath: null,

            uploadTimeStamp: {
                startPresignedUrl: null,
                endPresignedUrl: null,
                startUploadToS3: null,
                endUploadToS3: null,
                startSaveFile: null,
                endSaveFile: null
            },

            form: {
                notes: ""
            }
        };
    },

    methods: {
        openModal(item) {
            this.refund = item;
            this.tempFile = null;
            this.previewUrl = null;
            this.uploadedPath = null;
            this.form = { notes: "" };
            this.isShowLoadingOverlay = false;
            this.resetTimeStamps();
            this.$bvModal.show("m-konfirmasi-refund");
        },

        onHidden() {
            this.refund = null;
            this.tempFile = null;
            this.previewUrl = null;
            this.uploadedPath = null;
            this.form = { notes: "" };
            this.isShowLoadingOverlay = false;
            this.resetTimeStamps();
        },

        resetTimeStamps() {
            this.uploadTimeStamp = {
                startPresignedUrl: null,
                endPresignedUrl: null,
                startUploadToS3: null,
                endUploadToS3: null,
                startSaveFile: null,
                endSaveFile: null
            };
        },

        formatTime(date) {
            const hh = String(date.getHours()).padStart(2, "0");
            const mm = String(date.getMinutes()).padStart(2, "0");
            const ss = String(date.getSeconds()).padStart(2, "0");
            return `${hh}:${mm}:${ss}`;
        },

        async onFileChange(e) {
            if (!e || !e.target || !e.target.files || !e.target.files.length) return;
            const file = e.target.files[0];

            if (file.size > 5 * 1024 * 1024) {
                this.$helper.toastError(this, "Ukuran file maksimal 5MB.");
                this.tempFile = null;
                return;
            }

            this.isUploading = true;
            this.isShowLoadingOverlay = true;
            this.uploadedPath = null;
            this.resetTimeStamps();

            this.uploadTimeStamp.startPresignedUrl = this.formatTime(new Date());

            try {
                const payload = {
                    file_name: file.name,
                    file_type: file.type,
                    reference_key: String(this.refund.id),
                    directory_path: "concert-refunds"
                };

                const res = await this.$axios.post("get-presigned-url", payload);
                this.uploadTimeStamp.endPresignedUrl = this.formatTime(new Date());
                const { presigned_url, file_path } = res.data.data;

                this.uploadTimeStamp.startUploadToS3 = this.formatTime(new Date());
                const uploadRes = await fetch(presigned_url, {
                    method: "PUT",
                    body: file,
                    headers: { "Content-Type": file.type }
                });

                if (!uploadRes.ok) throw new Error("Upload ke S3 gagal.");
                this.uploadTimeStamp.endUploadToS3 = this.formatTime(new Date());

                this.uploadedPath = `concert-refunds/${this.refund.id}/${file_path}`;
                this.previewUrl = URL.createObjectURL(file);
            } catch (err) {
                this.$helper.toastError(this, "Gagal mengupload bukti transfer.");
                this.tempFile = null;
                this.previewUrl = null;
                this.uploadedPath = null;
                this.resetTimeStamps();
            } finally {
                this.isUploading = false;
                this.isShowLoadingOverlay = false;
            }
        },

        confirmSubmit() {
            if (!this.uploadedPath) {
                return this.$helper.toastError(this, "Bukti transfer wajib diupload.");
            }

            let isConfirmed = confirm(
                "Konfirmasi bahwa transfer refund sudah dilakukan? Tindakan ini tidak dapat dibatalkan."
            );
            if (!isConfirmed) return;

            const payload = {
                proof_path: this.uploadedPath,
                notes: this.form.notes || null
            };

            this.isSubmitting = true;
            this.isShowLoadingOverlay = true;
            this.uploadTimeStamp.startSaveFile = this.formatTime(new Date());
            this.uploadTimeStamp.endSaveFile = null;

            this.$axios
                .post(`concerts/refunds/${this.refund.id}/confirm`, payload)
                .then(() => {
                    this.uploadTimeStamp.endSaveFile = this.formatTime(new Date());
                    this.$helper.toastSuccess(this, "Refund berhasil dikonfirmasi.");
                    this.$bvModal.hide("m-konfirmasi-refund");
                    this.$emit("refresh");
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                    this.resetTimeStamps();
                })
                .finally(() => {
                    this.isSubmitting = false;
                    this.isShowLoadingOverlay = false;
                });
        }
    }
};
</script>
